import Vue from 'vue'
import Vuex from 'vuex'
import { FeathersVuex, socket, xlsxService } from '../feathers-client'
import auth from './store.auth'
import DraftFinding from './modules/draft-finding'
import LocalFindings from './modules/local-findings'
import Uploads from './modules/uploads'
// import UI from './modules/ui'

Vue.use(Vuex)
Vue.use(FeathersVuex)

const requireModule = require.context(
  // The path where the service modules live
  './services',
  // Whether to look in subfolders
  false,
  // Only include .js files (prevents duplicate imports`)
  /.js$/
)

const servicePlugins = requireModule
  .keys()
  .map(modulePath => requireModule(modulePath).default)

socket.on('connect', () => {
  state.socket = true
});

// eslint-disable-next-line no-unused-vars
socket.on('disconnect', reason => {
  state.socket = false
});

const state = {
  loginDelay: 105,
  orgName: 'IACS',
  appName: 'ACB Report Manager',
  footer: `Copyright © ${new Date().getFullYear()} International Association of Classification Societies. All Rights Reserved`,
  acUserSelectedCS: 0,
  newSubmissionCount: 99,
  importedSubmissionCount: 77,
  socket: false
}

export default new Vuex.Store({
  state,
  modules: {
    DraftFinding,
    LocalFindings,
    Uploads
  },
  mutations: {
    storeACUserSelectedCS (state, value) {
      state.acUserSelectedCS = value
    }
  },
  actions: {
    setACUserSelectedCS (context, value) {
      context.commit('storeACUserSelectedCS', value)
    },
    async getXLSXDoc (context, { query }) {
      const { doc, filename } = await xlsxService.get(null, { query })
      const blob = new Blob([doc], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.download = `${filename}.xlsx`;
      a.href = url;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  },
  plugins: [...servicePlugins, auth]
})
